import { useRef } from "react";
import {
  DatabaseReference,
  DataSnapshot,
  off,
  onChildAdded,
} from "firebase/database";
import eventBlacklistFirebase from "../eventBlacklist.firebase";

const useEventBlacklistActions = () => {
  const eventBlacklistRef = useRef<DatabaseReference | null>(null);

  const subscribe = (
    eventId: string,
    userId: string,
    onBlacklist: () => void,
  ) => {
    eventBlacklistRef.current =
      eventBlacklistFirebase.getEventBlacklistDocRef(eventId);
    off(eventBlacklistRef.current);
    onChildAdded(eventBlacklistRef.current, (snapshot: DataSnapshot) => {
      if (snapshot.key === userId) {
        onBlacklist();
      }
    });
  };

  const unsubscribe = () => {
    if (eventBlacklistRef.current) {
      off(eventBlacklistRef.current);
      eventBlacklistRef.current = null;
    }
  };

  return {
    subscribe,
    unsubscribe,
  };
};

export default useEventBlacklistActions;
